export enum NOTIFY_STATUSES {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    DEFAULT = 'DEFAULT',
}

export const AUTO_CLOSE_DURATION = 3000;
